<template>
  <ul class="commentsUl_flat">
    <template v-for="(item, index) in new_comments_list">
      <li class="commentsItem" v-if="item.comment_approved && item.status == 'publish'" :key="item.comment_ID">
        <div class="commentLayout">
          <div class="personInfoBox">
            <!-- <div class="personPhoto icon-cm-icontouxiang iconfont"></div> -->
            <div class="personInfo">
              <span class="name secondary_title">{{ item.name }}</span>
              <span class="country" v-if="comment.comment_country == 'yes' && item.country">
                <country-flag :country="item.country=='UK'?'GB':item.country" size="small" />
                {{ item.country }}
              </span>
              <i class="iconfont icon-dianzan"></i>
            </div>
          </div>
          <div class="contentBox">
            <div class="star">
              <v-commentsstar :disabled="true" :average_rating="item.rating" font_size="18"></v-commentsstar>
            </div>
            <p class="comment_detail page_text_font" v-text="item.content"></p>
            <div class="comment_photo" v-if="item.gallery.length">
              <img
                v-for="(subitem, subindex) in item.gallery"
                :key="subitem.ID"
                :src="subitem.thumbnail"
                @click="showBigImg(item.gallery, subindex)"
                alt
              />
            </div>
            <div class="date_help">
              <div>
                <p class="country_time secondary_title">
                  <span class="date" v-if="comment.comment_time == 'yes'">{{ item.comment_date }}</span>
                </p>
              </div>
              <div class="help_right" v-if="comment_mode != 'page'">
                <!-- <p class="helpful_num secondary_title" v-if="comment.comment_account == 'yes' && item.like_account > 0">
                  {{ item.like_account }}
                  {{ $t('comment.people_found_this_helpful') }}
                </p>
                <span class="helpful secondary_title" v-show="item.help_show" @click="comment_helpful(item, index)">{{
                  $t('comment.helpful')
                }}</span>
                <span class="helpful_tips secondary_title" v-show="!item.help_show">{{
                  $t('comment.thank_you_for_your_feedback')
                }}</span> -->

                <span class="report secondary_title" v-show="item.abuse_show" @click="click_abuse(item, index)">{{
                  $t('comment.report_as_inappropriate')
                }}</span>
                <span class="report secondary_title" v-show="!item.abuse_show">{{
                  $t('comment.this_review_has_been_reported')
                }}</span>
                <div class="giveLike">
                  <i
                    @click="comment_helpful(item, index)"
                    class="iconfont icon-cm-dianzan"
                    style="cursor: pointer; font-size: 16px"
                    :style="{
                      color:!item.help_show && 'rgb(82, 196, 26)',
                      'pointer-events':!item.help_show && 'none'
                      }"
                  >
                  </i>
                  <div class="giveLike_number" v-if="comment.comment_account == 'yes'">
                    {{ item.like_account > 999 ?'999+' : (item.like_account || 0) }}
                  </div>
                </div>
              </div>
            </div>
            <v-commentReply
              v-if="item.reply && item.reply.length"
              :reply="item.reply"
              style="padding: 0 0;"
            ></v-commentReply>
          </div>
        </div>
      </li>
    </template>
  </ul>
</template>
<script>
import vCommentsstar from './commentsstar'
import vCommentReply from './commentReply.vue'

export default {
  props: ['comment_mode', 'comment', 'new_comments_list', 'showBigImg', 'comment_helpful', 'click_abuse'],
  data() {
    return {}
  },
  components: {
    vCommentsstar,
    CountryFlag: resolve => {require(['vue-country-flag'], resolve)},
    vCommentReply,
  },
  watch: {
    new_comments_list(newV) {
      console.log(newV, 'newVnewV')
    },
  },
}
</script>
<style scoped lang='scss'>
.commentsUl_flat {
  padding: 0;
  margin-bottom: 20px;
  .commentsItem {
    box-shadow: 0px 2px 16px 0px #f1f2f3;
    border-radius: 8px;
    color: #666;
    // margin: 0;
    margin-top: 20px;
    -webkit-tap-highlight-color: transparent;
    outline: 0;
    list-style: none;
    position: relative;
    padding: 20px 24px;
    background: #fff;
    // max-width: 360px;
    .commentLayout {
      display: flex;
      .personInfoBox {
        width: 200px;
        padding-right: 15px;
        .personPhoto {
          margin: 0;
          padding: 0;
          -webkit-tap-highlight-color: transparent;
          margin-top: 0;
          position: absolute;
          width: 40px;
          height: 40px;
          left: 0;
          top: 20px;
          font-size: 30px;
          border-radius: 50%;
          color: white;
          overflow: hidden;
          background-color: #999;
          line-height: 52px;
          text-align: center;
        }
        .personInfo {
          display: flex;
          flex-direction: column;
          .name {
            padding: 0;
            -webkit-tap-highlight-color: transparent;
            word-break: break-word;
            font-family: ArapeyRegular;
            font-size: 16px;
            color: #222;
            margin-bottom: 6px;
            display: inline-block;
            position: relative;
            line-height: 20px;
            font-weight: 600;
          }
          .country {
            .flag {
              box-sizing: content-box;
              border: 1px solid #dedede;
              margin-right: -14px;
            }
          }
        }
      }
      .contentBox {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        width: 100%;
        .star {
          margin-bottom: 8px;
        }
        .comment_detail {
          font-size: 14px;
          line-height: 21px;
          margin: 0;
          color: #333;
        }
        .comment_photo {
          img {
            padding: 0;
            -webkit-tap-highlight-color: transparent;
            width: 52px;
            height: 52px;
            display: inline-block;
            background: #f2f2f2;
            margin: 12px 12px 12px 0px;
            box-sizing: border-box;
            cursor: zoom-in;
            object-fit: cover;
          }
        }
        .date_help {
          display: flex;
          justify-content: space-between;
          width: 100%;
          align-items: center;
          margin-top: 8px;
          .country_time {
            margin: 0;
            padding: 0;
            font-size: 12px;
            color: #999;
          }
          .help_right {
            color: #999;
            display: flex;
            align-items: baseline;
            .giveLike {
              display: flex;
              align-items: center;
              .giveLike_number {
                margin-left: 5px;
                font-size: 12px;
                width: 28px;
              }
            }
            .helpful_num {
              font-size: 14px;
              color: #999;
              margin: 0;
              padding-bottom: 14px;
            }
            .helpful {
              margin: 0;
              padding: 0;
              -webkit-tap-highlight-color: transparent;
              // width: 68px;
              height: 28px;
              background: #fff;
              display: inline-block;
              line-height: 28px;
              text-align: center;
              border: 1px solid #ddd;
              border-radius: 2px;
              cursor: pointer;
              color: #333;
              font-size: 14px;
              padding: 0 10px;
            }
            .helpful_tips {
              list-style: none;
              margin: 0;
              padding: 0;
              -webkit-tap-highlight-color: transparent;
              color: #008100;
              font-size: 14px;
              display: inline;
            }
            .report {
              margin: 0;
              padding: 0;
              white-space: normal;
              -webkit-tap-highlight-color: transparent;
              cursor: pointer;
              color: #999;
              font-size: 14px;
              margin-top: 0;
              line-height: 24px;
              width: 100%;
              // border-left: 1px solid #ddd;
              padding-right: 10px;
              margin-right: 10px;
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and(max-width: 767px) {
  .commentsUl_flat {
    .commentsItem {
      margin: 15px 0px;
      .commentLayout {
        display: flex;
        flex-direction: column;
        .personInfoBox {
          width: unset;
          padding-right: 0;
          .personPhoto {
            margin-right: 10px;
            position: unset;
          }
          .personPhoto,
          .personInfo {
            display: inline-block;
          }
        }
      }
      .report {
        margin-left: 5px;
        padding-left: 5px;
        font-size: 12px;
      }
    }
  }
  .commentsUl_waterfall {
    column-count: 1 !important;
  }
}
</style>